import {
  productCategoryFieldMapping,
} from '../../Enum/FieldMapping/ProductCategoryFieldMapping';
import { dashboardAction } from '../../Store/Reducers/DashboardReducer';
import { mappingActions } from '../../Store/Reducers/MappingReducer';
import { utilsActions } from '../../Store/Reducers/UtilsReducer';
import {
  isContent,
  isContentErr,
} from '../../Utils/Response/Response';
import {
  getDetailExistingProductCategory,
  getDetailProductCategory,
  postApproveMappingProductCategory,
  postProductCategoryCountData,
  postProductCategoryList,
  postProductCategorySearchCountData,
  postSearchProductCategoryList,
} from '../Api/ProductCategoryAPI';
import {
  reloadList,
  setDefaultPagination,
} from './DashboardData';
import {
  approvalAction,
  approvalActionErr,
  setMappingForm,
  setMappingSearch,
  setMappingSearchErr,
} from './MappingData';

export const fetchDataProductCategoryList = (
  totalRow,
  countData,
  token,
  currentPage,
  rowLimit,
  sortDate,
  dispatch,
  notify
) =>
  postProductCategoryCountData(token, notify, dispatch, response =>
    listData(
      response,
      totalRow,
      countData,
      token,
      currentPage,
      rowLimit,
      sortDate,
      dispatch,
      notify
    )
  );

const listData = async (
  res,
  totalData,
  countData,
  token,
  currentPage,
  rowLimit,
  sortDate,
  dispatch,
  notify
) => {
  await dispatch(mappingActions.setCountData(isContent(res)));
  await dispatch(dashboardAction.setTotalRow(isContent(res)));
  if (totalData === countData) {
    postProductCategoryList(token, currentPage, rowLimit, sortDate, dispatch, notify, response =>
      dispatch(mappingActions.setList(isContent(response)))
    );
  } else {
    setDefaultPagination(dispatch);
    await postProductCategoryList(token, 1, 10, sortDate, dispatch, notify, response =>
      reloadList(response, dispatch, countData)
    );
  }
  dispatch(utilsActions.setLoading(false));
};
export const fetchProductCategoryMappingForm = async (
  token,
  dispatch,
  uniqueKey,
  NewId,
  ExistId,
  list,
  notify,
  navigate
) => {
  const newData = await getDetailProductCategory(
    token,
    NewId,
    notify,
    dispatch,
    res => isContent(res),
    err => isContentErr(err)
  );
  const existData = await getDetailExistingProductCategory(
    token,
    ExistId,
    notify,
    dispatch,
    res => isContent(res),
    err => isContentErr(err)
  );
  await setMappingForm(productCategoryFieldMapping, list, uniqueKey, newData, existData, dispatch);
  navigate();
};

export async function fetchDataApprovalProductCategory(
  token,
  data,
  mappingList,
  mappingCount,
  notify,
  dispatch
) {
  return postApproveMappingProductCategory(
    token,
    data,
    notify,
    dispatch,
    res => approvalAction(res, mappingList, mappingCount, dispatch),
    err => approvalActionErr(err, dispatch)
  );
}
export async function fetchSearchProductCategoryList(token, data, column, dispatch, notify) {
  await postSearchProductCategoryList(token, data, dispatch, notify,
    res=>setMappingSearch(res,column,dispatch),
    err=>setMappingSearchErr(err, dispatch))
}
export const fetchDataProductCategorySearchList = async (
  token,
  currentPage,
  rowLimit,
  filter,
  column,
  dispatch,
  notify
) => {
  postProductCategorySearchCountData(token, filter, notify, dispatch, response =>
    listSearchData(
      response,
      token,
      currentPage,
      rowLimit,
      filter,
      column,
      dispatch,
      notify
    )
  );
};
const listSearchData = async (
  res,
  token,
  currentPage,
  rowLimit,
  filter,
  column,
  dispatch,
  notify
) => {
  let data = await {...{page: currentPage, limit: Number(rowLimit)}, ...filter};
  await postSearchProductCategoryList(
    token,
    data,
    dispatch,
    notify,
    reponse => setMappingSearch(reponse, column, isContent(res), dispatch),
    err => setMappingSearchErr(err, isContent(res), dispatch)
  );
  dispatch(utilsActions.setLoading(false));
};